<template>
  <main-layout :selectedMenu="'myHome'">
    <div class="containerBox" @click="isShowResume=null,isShowType=false,isShowStatus=null">
      <div class="container">
        <asideCom :activityIndex="2" :resumeNumber="resumeNumber"></asideCom>
        <div class="Resume">
            <p class="title">收到的简历</p>
            <div class="box">
                <div class="changeBox">
                    <div class="typeBox">
                        <div class="title1" @click.stop.prevent="isShowType = !isShowType,isShowResume=null,isShowStatus=null">
                            {{resumeName}}<img src="https://image.manamana.net/1657164309000_aNyRNPZq" alt="">
                        </div>
                        <div class="list" v-if="isShowType">
                            <div class="listBox">
                                <div class="li li1" @click="changeRecruitId(null)">全部</div>
                                <div :class="[item.status == 3 ? 'li li1' : 'li li2']" @click="changeRecruitId(item)" v-for="(item,i) in recruitList" :key="i">{{item.positionName}} · 上海 · {{item.negotiable == 1 ? '面议' : item.salaryBegin + 'K' + '-' + item.salaryEnd + 'K'}}<span v-if="item.status == 4">已下线</span></div>
                            </div>
                        </div>
                    </div>
                    <div class="typeText">
                        <span :class="[!type?'active':'']" @click="changeType(null)">全部</span>
                        <span :class="[type==1?'active':'']" @click="changeType(1)">待联系</span>
                        <span :class="[type==2?'active':'']" @click="changeType(2)">已约面</span>
                        <span :class="[type==3?'active':'']" @click="changeType(3)">不合适</span>
                    </div>
                </div>
                <div class="contentBox">
                    <div class="boxContent">
                        <div :class="['content clearfix',item.unRead == 1 || (resumeItem.unRead == 1 && resumeItem.id == item.id) ? 'seeed': '']" @click.stop.prevent="isShowPopResume(i,item)" v-for="(item,i) in list" :key="i">
                            <div class="line" v-show="isShowResume == i+1"></div>
                            <div class="box1">
                                <p class="info">应聘岗位：{{item.positionName}} · {{item.cityName}} · {{item.negotiable == 1 ? '面议' : item.salaryBegin + 'K' + '-' + item.salaryEnd + 'K'}}<span>应聘时间：{{item.applyTime | formatDate("YYYY.MM.DD")}}</span></p>
                                <div class="aractBox clearfix">
                                    <div class="imgBox" @click.stop.prevent="gotoPeople(item.userId)">
                                        <img class="acartImg" :src="item.avatar | imageUrl('',156,156)" alt="">
                                        <img class="genderImg" :src="item.gender == 1 ? 'https://image.manamana.net/1657164336000_qqLGIZKL':'https://image.manamana.net/1657164354000_mZFYvNei'" alt="">
                                    </div>
                                    <div class="textBox">
                                        <p class="name">{{item.name}}</p>
                                        <p class="year"><i>{{getBirthday(item.beginWorkTime)}}年 |</i> {{getBirthday(item.birthday)}}岁 | <i v-if="item.education">{{getEducation(item.education)}} |</i> {{item.schoolName}}</p>
                                        <p class="jobName"><span v-for="(job,y) in item.workCompanyNamesList" :key="y">{{job}}<i v-if="y<item.workCompanyNamesList.length-1">/</i></span></p>
                                    </div>
                                </div>
                            </div>
                            <div class="box2">
                                <p class="phone" v-if="item.mobile" @click.stop.prevent><img src="https://image.manamana.net/1657164373000_nNwKvtcD" alt="">{{item.mobile}}</p>
                                <p class="email" v-if="item.email" @click.stop.prevent><img src="https://image.manamana.net/1657164382000_XKgXzeCm" alt="">{{item.email}}</p>
                                <p class="wechat" v-if="item.wechatLink" @click.stop.prevent><img src="https://image.manamana.net/1657164390000_RZdLAedK" alt="">{{item.wechatLink}}</p>
                            </div>
                            <div class="box3">
                                <div class="but" @click.stop.prevent="isShowPopStatus(i)">{{getStatus(item.status)}}<img src="https://image.manamana.net/1657164448000_RvnclDRP" alt=""></div>
                                <div class="status" v-if="isShowStatus == i+1">
                                    <div class="statusBox">
                                        <p @click.stop.prevent="changeStatus(1,item)">待联系</p>
                                        <p @click.stop.prevent="changeStatus(2,item)">已约面</p>
                                        <p @click.stop.prevent="changeStatus(3,item)">不合适</p>
                                    </div>
                                </div>
                            </div>
                            <div class="popBox" v-if="isShowResume == i+1" @click.stop.prevent>
                                <div class="infoBox">
                                    <p class="title">投递 - {{resumeItem.positionName}}<span>{{resumeItem.applyTime | formatDate("MM月DD日 HH:mm")}}</span></p>
                                    <div class="topBox clearfix">
                                        <div class="imgBox" @click.stop.prevent="gotoPeople(resumeItem.userId)">
                                            <img class="acartImg" :src="recruitResumeBaseResponse.avatar | imageUrl('',150,150)" alt="">
                                            <img class="genderImg" :src="recruitResumeBaseResponse.gender == 1 ?'https://image.manamana.net/1657164336000_qqLGIZKL':'https://image.manamana.net/1657164354000_mZFYvNei'" alt="">
                                        </div>
                                        <div class="phoneBox">
                                            <p class="name">{{recruitResumeBaseResponse.name}}<span>{{getStatus(resumeItem.status)}}</span></p>
                                            <p class="year"><i v-if="recruitResumeBaseResponse.idType == 1">{{getBirthday(recruitResumeBaseResponse.beginWorkTime)}}年  |</i>  {{getBirthday(recruitResumeBaseResponse.birthday)}}岁  <i v-if="recruitResumeBaseResponse.education">|  {{getEducation(recruitResumeBaseResponse.education)}}</i>  |  {{getJobs(recruitResumeBaseResponse.jobStatus)}} | {{getCityName(recruitResumeBaseResponse.areaName)}}</p>
                                            <p class="numberBox">
                                                <span class="phone" v-if="recruitResumeBaseResponse.mobile"><img src="https://image.manamana.net/1657164373000_nNwKvtcD" alt="">{{recruitResumeBaseResponse.mobile}}</span
                                                ><span class="email" v-if="recruitResumeBaseResponse.email"><img src="https://image.manamana.net/1657164382000_XKgXzeCm" alt="">{{recruitResumeBaseResponse.email}}</span
                                                ><span class="wechat" v-if="recruitResumeBaseResponse.wechatLink"><img src="https://image.manamana.net/1657164390000_RZdLAedK" alt="">{{recruitResumeBaseResponse.wechatLink}}</span>
                                            </p>
                                        </div>
                                        <div class="upload">
                                            <div class="upload1" @click.stop.prevent="gotoPreview"><img src="https://image.manamana.net/1657174603000_DVGQgWvM" alt=""><p>下载简历</p></div>
                                            <div class="upload2" v-if="resumeItem.linkPath" @click.stop.prevent="uploadLink"><img src="https://image.manamana.net/1657174612000_beZNnrqe" alt=""><p>下载作品集</p></div>
                                            <el-popover
                                                placement="top"
                                                trigger="hover"
                                                v-else
                                            >
                                                <div class="raesonText">应聘者未上传作品</div>
                                                <div class="upload4" slot="reference"><img src="https://image.manamana.net/1657181723000_MQiDiTgC" alt=""><p>下载作品集</p></div>
                                            </el-popover>
                                            <div class="upload3" @click.stop.prevent="showReport"><img src="https://image.manamana.net/1657174875000_PUBKxnAs" alt=""><p>举报</p></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="scrollBox">
                                    <div class="titleBox" v-if="resumeItem.onLineResume == 1">
                                        <div class="boxLi">
                                            <div class="content1">
                                                <p class="titleHead">个人优势</p>
                                                <div class="textBox">
                                                    <div class="htmlText htmlText1" v-html="getHtml(recruitResumeAdvantageResponse.advantage)"></div>
                                                </div>
                                            </div>
                                            <div class="content1" v-if="recruitResumeWorkExperienceResponses.length">
                                                <p class="titleHead">工作经历</p>
                                                <div class="textBox" v-for="(item,i) in recruitResumeWorkExperienceResponses" :key="i">
                                                    <div class="textName"><span></span><p class="name">{{item.companyName}}</p></div>
                                                    <div class="time"><p>{{item.positionName}}</p><span>{{item.workBeginTime | formatDate("YYYY.MM")}} - <b v-if="item.workEndTime">{{item.workEndTime | formatDate("YYYY.MM")}}</b><b v-else>至今</b></span></div>
                                                    <div class="htmlText" v-html="getHtml(item.workContent)"></div>
                                                </div>
                                            </div>
                                            <div class="content1" v-if="recruitResumeProjectExperienceResponses.length">
                                                <p class="titleHead">项目经历</p>
                                                <div class="textBox" v-for="(item,i) in recruitResumeProjectExperienceResponses" :key="i">
                                                    <div class="textName"><span></span><p class="name">{{item.projectName}}</p></div>
                                                    <div class="time"><p>{{item.projectRole}}</p><span>{{item.projectCycleBegin | formatDate("YYYY.MM")}} - <b v-if="item.projectCycleEnd">{{item.projectCycleEnd | formatDate("YYYY.MM")}}</b><b>至今</b></span></div>
                                                    <div class="htmlText" v-html="getHtml(item.projectDes)"></div>
                                                    <div class="htmlText" v-html="getHtml(item.projectPerformance)"></div>
                                                    <p class="link" v-if="item.projectLink">项目链接：<a target="_blank" :href="item.projectLink">{{item.projectLink}}</a></p>
                                                </div>
                                            </div>
                                            <div class="content1" v-if="recruitResumeEducationExperienceResponses.length">
                                                <p class="titleHead">教育经历</p>
                                                <div class="textBox" v-for="(item,i) in recruitResumeEducationExperienceResponses" :key="i">
                                                    <p class="textName"><span></span>{{item.schoolName}}<i>{{item.schoolStartTime | formatDate("YYYY.MM")}} - <b v-if="item.schoolEndTime">{{item.schoolEndTime | formatDate("YYYY.MM")}}</b><b v-else>至今</b></i></p>
                                                    <p class="education">{{getEducation(item.education)}} | {{item.major}}</p>
                                                </div>
                                            </div>
                                            <div class="content2" v-if="recruitResumeProductShowResponse.videoDomains.length">
                                                <p class="titleHead">作品展示</p>
                                                <div class="videoList clearfix">
                                                    <div class="videoLi" v-for="(item,i) in recruitResumeProductShowResponse.videoDomains" :key="i" @click="gotoVideo(item.id)">
                                                        <img :src="item.thumb | imageUrl('',277,160)" alt="">
                                                        <p class="videoTitle">{{item.title}}</p>
                                                        <p class="tags"><span v-for="(tag,y) in item.categoryTagGroupInfoList" :key="y">{{tag}}</span></p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="fileBox" v-if="resumeItem.onLineResume == 0">
                                        <img @click.stop.prevent="gotoPreview" src="https://image.manamana.net/1657863403000_sMBOEqmX" alt="">
                                        <p>简历为附件简历，请下载查看</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Loading v-if="loading" />
                    <Reload v-if="loadError" @callback="loadMore" />
                    <no-more v-if="!hasNextPage && list.length" />
                    <div class="noData" v-if="!list.length">
                        <img src="https://image.manamana.net/1657182811000_CIhDOTIe" alt="">
                        <p>暂无数据</p>
                    </div>
                </div>
            </div>
        </div>
        </div>
    </div>
    <el-dialog :visible.sync="reportVisible" width="22%">
          <el-form ref="form" :model="form" label-position="top">
            <el-form-item :label="`${$t('global.请填写举报理由')}：`">
              <el-checkbox-group v-model="form.reason">
                <el-checkbox
                  :label="$t('global.涉及黄赌毒和暴力')"
                  name="reason"
                ></el-checkbox>
                <el-checkbox :label="$t('global.政治')" name="reason"></el-checkbox>
                <el-checkbox
                  :label="$t('global.版权问题')"
                  name="reason"
                ></el-checkbox>
                <el-checkbox :label="$t('global.抄袭')" name="reason"></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item>
              <el-input
                type="textarea"
                wrap="hard"
                v-model="form.content"
                :placeholder="$t('global.请输入举报内容，我们将尽快处理。')"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click.stop.prevent="onSubmit">{{
                $t("global.提交")
              }}</el-button>
            </el-form-item>
            <el-form-item>
              <p class="message">
                {{ $t("global.也可发邮件给我们") }}：info@manamana.net
              </p>
            </el-form-item>
          </el-form>
        </el-dialog>
  </main-layout>
</template>

<script type="text/ecmascript-6">
import MainLayout from "@/layouts/MainLayout";
import asideCom from "@/components/aside.vue";
import Reload from "@/components/v2/match/reload";
import Loading from "@/components/v2/match/loading";
import NoMore from "@/components/v2/NoMore";
import {
  getScrollHeight,
  getScrollTop,
  getWindowHeight
} from "@/assets/screen";
export default {
  name: "Resume",
  metaInfo() {
    return {
      title: "收到的简历 | MANA"
    };
  },
  data() {
    return {
      type: null,
      isShowStatus: null,
      isShowType: false,
      isShowResume: null,
      list: [],
      pageIndex: 1,
      recruitId: null,
      loading: false,
      hasNextPage: false,
      loadError: false,
      recruitList: [],
      recruitResumeAdvantageResponse: {}, //个人优势
      recruitResumeBaseResponse: {}, //基本信息
      recruitResumeEducationExperienceResponses: [], //教育经历
      recruitResumeExpectationResponses: [], //求职期望
      recruitResumeProductShowResponse: {}, //作品展示
      recruitResumeProjectExperienceResponses: [], //项目经历
      recruitResumeWorkExperienceResponses: [], //工作经历
      resumeFile: {}, //简历附件
      videoFile: {}, //作品集附件
      resumeItem: {},
      resumeNumber: 0,
      flag: true,
      id: null,
      resumeName: "全部职位",
      reportVisible: false,
      form: {
        reason: [],
        content: "",
      },
    };
  },
  components: {
    MainLayout,
    asideCom,
    Reload,
    Loading,
    NoMore,
  },
  created() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
    } else {
      this.id = null;
    }
    this.getList();
    this.getRecruitList();
    this.getUnread();
  },
  mounted() {
    window.addEventListener("scroll", this.loadMore);
  },
  destroyed() {
    window.removeEventListener("scroll", this.loadMore, false);
  },
  computed: {
    language() {
      return this.$language();
    }
  },
  methods: {
    onSubmit() {
      var $this = this;
      this.$http
        .post(
          "/api/u/report/?reason=" +
            this.form.reason.toString() +
            "&content=" +
            this.form.content +
            "&domainId=" +
            this.resumeItem.userId +
            "&type=12"
        )
        .then(function (response) {
          if (response.code === "OK") {
            $this.$message.success($this.$t("global.提交成功"));
            setTimeout(() => {
              $this.reportVisible = false;
            }, 2000);
          }
        });
    },
    showReport() {
      this.reportVisible = true;
    },
    getHtml(text) {
      let value = "";
      if (text) {
        value = text.replace(/(\r\n|\n|\r)/gm, "<br />");
      }
      return value;
    },
    getUnread() {
      this.$http.get("/api/u/recruit/manage/unread").then(res => {
        if (res.code == "OK") {
          this.resumeNumber = res.data;
        }
      });
    },
    uploadLink() {
      var imgUrl = "https://file.manamana.net/" + this.resumeItem.linkPath;
      fetch(imgUrl).then(res =>
        res.blob().then(blob => {
          let a = document.createElement("a");
          let url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = "";
          a.click();
          window.URL.revokeObjectURL(url);
        })
      );
    },
    gotoPeople(id) {
      let routeData = this.$router.resolve({
        path: "/peopleCenter/" + id + "/home"
      });
      window.open(routeData.href, "_blank");
    },
    gotoVideo(id) {
      let routeData = this.$router.resolve({
        path: "/video/detail?id=" + id
      });
      window.open(routeData.href, "_blank");
    },
    gotoPreview() {
      if (this.resumeItem.onLineResume == 1) {
        let routeData = this.$router.resolve({
          path:
            "/previewResume/" +
            this.resumeItem.userId +
            "?positionName=" +
            this.resumeItem.positionName +
            "&name=" +
            this.recruitResumeBaseResponse.name
        });
        window.open(routeData.href, "_blank");
      }
      if (this.resumeItem.onLineResume == 0) {
        var imgUrl = "https://file.manamana.net/" + this.resumeItem.resumePath;
        fetch(imgUrl).then(res =>
          res.blob().then(blob => {
            let a = document.createElement("a");
            let url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = this.resumeItem.resumeName;
            a.click();
            window.URL.revokeObjectURL(url);
          })
        );
      }
    },
    changeStatus(status, item) {
      this.$http
        .post("/api/u/recruit/manage/status/" + item.id + "/" + status)
        .then(res => {
          if (res.code == "OK") {
            this.$message.success(res.message);
            item.status = status;
            this.isShowStatus = null;
          }
        });
    },
    getCityName(city) {
      if (city) {
        var cityList = city.split(" ");
        return cityList[cityList.length - 1];
      } else {
        return "";
      }
    },
    getStatus(i) {
      if (i == 1) {
        return "待联系";
      }
      if (i == 2) {
        return "已约面";
      }
      if (i == 3) {
        return "不合适";
      }
    },
    getEducation(i) {
      if (i == 1) {
        return "其他";
      }
      if (i == 2) {
        return "大专";
      }
      if (i == 3) {
        return "本科";
      }
      if (i == 4) {
        return "硕士";
      }
      if (i == 5) {
        return "博士";
      }
    },
    getJobs(i) {
      if (i == 1) {
        return "随时入职";
      }
      if (i == 2) {
        return "考虑机会";
      }
      if (i == 3) {
        return "暂不考虑";
      }
    },
    getBirthday(strBirthday) {
      if(!strBirthday || strBirthday < 0) {
        return 0
      }
      let date = new Date(strBirthday);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let dd = date.getDate();
      dd = dd < 10 ? "0" + dd : dd;
      strBirthday = y + "-" + MM + "-" + dd;
      var returnAge;
      var strBirthdayArr = strBirthday.split("-");
      var birthYear = strBirthdayArr[0];
      var birthMonth = strBirthdayArr[1];
      var birthDay = strBirthdayArr[2];
      var d = new Date();
      var nowYear = d.getFullYear();
      var nowMonth = d.getMonth() + 1;
      var nowDay = d.getDate();

      if (nowYear == birthYear) {
        returnAge = 0; //同年 则为0岁
      } else {
        var ageDiff = nowYear - birthYear; //年之差
        if (ageDiff > 0) {
          if (nowMonth == birthMonth) {
            var dayDiff = nowDay - birthDay; //日之差
            if (dayDiff < 0) {
              returnAge = ageDiff - 1;
            } else {
              returnAge = ageDiff;
            }
          } else {
            var monthDiff = nowMonth - birthMonth; //月之差
            if (monthDiff < 0) {
              returnAge = ageDiff - 1;
            } else {
              returnAge = ageDiff;
            }
          }
        } else {
          returnAge = -1; //返回-1 表示出生日期输入错误 晚于今天
        }
      }

      return returnAge; //返回周岁年龄
    },
    changeRecruitId(item) {
      if (item) {
        this.recruitId = item.id;
        this.resumeName = item.positionName;
      } else {
        this.resumeName = "全部职位";
      }
      this.pageIndex = 1;
      this.getList();
    },
    changeType(type) {
      this.pageIndex = 1;
      this.type = type;
      this.getList();
    },
    getRecruitList() {
      this.$http.get("/api/u/recruit/manage/recruit/info").then(res => {
        if (res.code == "OK") {
          this.recruitList = res.data;
        }
      });
    },
    loadMore() {
      if (getScrollTop() + getWindowHeight() >= getScrollHeight() - 500) {
        if (!this.loading && this.hasNextPage) {
          this.getList();
        }
      }
    },
    getList() {
      this.loading = true;
      let params = {
        pageIndex: this.pageIndex,
        pageSize: 10,
        recruitId: this.recruitId,
        status: this.type,
        id: this.id ? Number(this.id) : null
      };
      this.$http
        .post("/api/u/recruit/manage/", params, {
          headers: {
            "Content-Type": "application/json"
          }
        })
        .then(res => {
          if (res.code == "OK") {
            if (this.pageIndex === 1) {
              this.list = [];
            }
            this.hasNextPage = res.data.hasNextPage;
            this.list = [...this.list, ...res.data.list];
            this.loading = false;
            this.loadError = false;
            this.pageIndex++;
            if (this.flag) {
              if (this.id) {
                if (
                  this.list.find(item => {
                    return item.id == this.id;
                  }) !== undefined
                ) {
                  var item = this.list.find(item => {
                    return item.id == this.id;
                  });
                  let index = this.list.findIndex(item => item.id == this.id);
                  this.isShowPopResume(index, item);
                  this.flag = false;
                  this.id = null;
                } else {
                  this.flag = false;
                  this.id = null;
                }
              }
            }
          } else {
            this.loadError = true;
            if (this.pageIndex !== 1) {
              this.pageIndex--;
            }
          }
        });
    },
    isShowPopResume(i, item) {
      this.$http
        .get("/api/u/recruit/resume/online/info/" + item.userId)
        .then(res => {
          if (res.code == "OK") {
            this.recruitResumeAdvantageResponse =
              res.data.recruitResumeAdvantageResponse;
            this.recruitResumeBaseResponse = res.data.recruitResumeBaseResponse;
            this.recruitResumeEducationExperienceResponses =
              res.data.recruitResumeEducationExperienceResponses;
            this.recruitResumeExpectationResponses =
              res.data.recruitResumeExpectationResponses;
            if (res.data.recruitResumeFileResponse.length) {
              for (
                let i = 0;
                i < res.data.recruitResumeFileResponse.length;
                i++
              ) {
                if (res.data.recruitResumeFileResponse[i].type == 1) {
                  this.resumeFile = res.data.recruitResumeFileResponse[i];
                }
                if (res.data.recruitResumeFileResponse[i].type == 2) {
                  this.videoFile = res.data.recruitResumeFileResponse[i];
                }
              }
            } else {
              this.resumeFile = null;
              this.videoFile = null;
            }
            this.recruitResumeProductShowResponse =
              res.data.recruitResumeProductShowResponse;
            this.recruitResumeProjectExperienceResponses =
              res.data.recruitResumeProjectExperienceResponses;
            this.recruitResumeWorkExperienceResponses =
              res.data.recruitResumeWorkExperienceResponses;
            this.isShowResume = i + 1;
            this.isShowStatus = null;
            this.isShowType = false;
            this.resumeItem = item;
            if (item.unRead == 0) {
              this.$http
                .get("/api/u/recruit/manage/read/" + item.id)
                .then(res => {
                  if (this.resumeNumber > 0) {
                    this.resumeNumber--;
                  }
                });
            }
          }
        });
    },
    isShowPopStatus(i) {
      this.isShowStatus = i + 1;
      this.isShowResume = null;
      this.isShowType = false;
    }
  },
  watch: {
    isShowResume(val) {
      if (!val) {
        this.resumeItem.unRead = 1;
      }
    }
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
.body {
  background: #FAFAFA;
}
.containerBox{
    width: 100%;
}
.container{
  width: 1110px;
  padding: 40px 0 120px 0;
  display: flex;
  margin: 0 auto;
  background: #FAFAFA;
  .Resume{
    width: 825px;
    padding-top: 16px;
    min-height: 100vh;
    .title{
        font-size: 24px;
        font-weight: 600;
        color: #333333;
        line-height: 36px;
        margin-bottom: 22px;
    }
    .box{
        background: #fafafa;
        border: 1px solid #E0E0E0;
        .changeBox{
            padding-top: 18px;
            background: #ffffff;
            .typeBox{
                padding-left: 15px;
                position: relative;
                padding-bottom: 20px;
                .title1{
                    font-size: 16px;
                    font-weight: 600;
                    color: #333333;
                    line-height: 22px;
                    cursor: pointer;
                    img{
                        width: 18px;
                        height: 19px;
                        margin-left: 8px;
                    }
                }
                .list{
                    position: absolute;
                    z-index: 111;
                    .listBox{
                        position: absolute;
                        left: 0;
                        top: 5px;
                        background: #FFFFFF;
                        box-shadow: 0px 2px 12px 0px rgba(0,0,0,0.06);
                        border: 1px solid #E4E7ED;
                        width: max-content;
                        padding: 15px 0;
                        .li{
                            font-size: 12px;
                            font-weight: 400;
                            cursor: pointer;
                            height: 26px;
                            line-height: 26px;
                            padding: 0 15px;
                            &:hover{
                                background: #F5F5F5;
                            }
                        }
                        .li1{
                            color: #333333;
                        }
                        .li2{
                            color: #999999;
                            span{
                                display: inline-block;
                                width: 46px;
                                height: 18px;
                                line-height: 18px;
                                text-align: center;
                                margin-left: 16px;
                                background: #F9F9F8;
                            }
                        }
                    }
                }
            }
            .typeText{
                height: 24px;
                padding-left: 15px;
                cursor: pointer;
                padding-bottom: 20px;
                border-bottom: 1px solid #EBEBEB;
                span{
                    margin-right: 20px;
                    display: inline-block;
                    font-size: 12px;
                    font-weight: 400;
                    color: #999999;
                    line-height: 24px;
                }
                span.active{
                    font-weight: 600;
                    color: #333333;
                    border-bottom: 2px solid #333;
                }
            }
        }
        .contentBox{
            padding-bottom: 40px;
            .boxContent{
                padding-bottom: 40px;
            }
            .content{
                background: #ffffff;
                border-bottom: 1px solid #EBEBEB;
                padding: 20px 15px;
                cursor: pointer;
                position: relative;
                &:last-child{
                    border-bottom: 0;
                }
                .line{
                    position: absolute;
                    width: 4px;
                    height: 138px;
                    background: #2026CC;
                    border-radius: 2px;
                    left: 0;
                    top: 0;
                }
                .box1{
                    float: left;
                    .info{
                        height: 18px;
                        font-size: 12px;
                        font-weight: 400;
                        color: #333333;
                        line-height: 18px;
                        span{
                            margin-left: 10px;
                        }
                    }
                    .aractBox{
                        margin-top: 10px;
                        .imgBox{
                            position: relative;
                            width: 52px;
                            height: 52px;
                            float: left;
                            margin-right: 10px;
                            .acartImg{
                                width: 52px;
                                height: 52px;
                                border-radius: 50%;
                            }
                            .genderImg{
                                position: absolute;
                                width: 16px;
                                height: 16px;
                                bottom: 0;
                                right: 0;
                            }
                        }
                        .textBox{
                            float: left;
                            width: 368px;
                            .name{
                                height: 22px;
                                font-size: 14px;
                                font-weight: 600;
                                color: #333333;
                                line-height: 22px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                            }
                            .year{
                                height: 18px;
                                font-size: 12px;
                                font-weight: 400;
                                color: #666666;
                                line-height: 18px;
                                margin: 8px 0 4px 0;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                            }
                            .jobName{
                                height: 18px;
                                font-size: 12px;
                                font-weight: 400;
                                color: #666666;
                                line-height: 18px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                            }
                        }
                    }
                }
                .box2{
                    float: left;
                    margin-top: 28px;
                    margin-left: 45px;
                    .phone{
                        height: 18px;
                        font-size: 12px;
                        font-weight: 400;
                        color: #666666;
                        line-height: 18px;
                        margin-bottom: 8px;
                        img{
                            width: 12px;
                            height: 16px;
                            margin-right: 5px;
                        }
                    }
                    .email{
                        height: 18px;
                        font-size: 12px;
                        font-weight: 400;
                        color: #666666;
                        line-height: 18px;
                        margin-bottom: 8px;
                        img{
                            width: 14px;
                            height: 12px;
                            margin-right: 5px;
                        }
                    }
                    .wechat{
                        height: 14px;
                        font-size: 12px;
                        font-weight: 400;
                        color: #666666;
                        line-height: 18px;
                        img{
                            width: 16px;
                            height: 14px;
                            margin-right: 5px;
                        }
                    }
                }
                .box3{
                    float: right;
                    margin-top: 46px;
                    position: relative;
                    .but{
                        width: 84px;
                        height: 30px;
                        line-height: 30px;
                        text-align: center;
                        border: 1px solid #2026CC;
                        font-size: 12px;
                        font-weight: 400;
                        color: #2026CC;
                        box-sizing: border-box;
                        img{
                            width: 18px;
                            height: 18px;
                        }
                    }
                    .status{
                        position: absolute;
                        width: 88px;
                        height: 88px
                        z-index: 111;
                        .statusBox{
                            position: absolute;
                            width: 88px;
                            height: 88px;
                            background: #FFFFFF;
                            box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.1);
                            padding: 4px 0;
                            box-sizing: border-box;
                            top: 5px;
                            left: -2px;
                            p{
                                height: 26px;
                                line-height: 26px;
                                text-align: center;
                                font-size: 12px;
                                font-weight: 400;
                                color: #333333;
                                &:hover{
                                    background: #F5F5F5;
                                }
                            }
                        }
                    }
                }
                .popBox{
                    position: absolute;
                    width: 670px;
                    background: #FFFFFF;
                    box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.2);
                    top: 10px;
                    left: 151px;
                    z-index: 111;
                    .infoBox{
                        height: 140px;
                        background: #F9FAFB;
                        padding: 20px 15px 20px 20px;
                        box-sizing: border-box;
                        .title{
                            height: 18px;
                            font-size: 14px;
                            font-weight: 500;
                            color: #333333;
                            line-height: 18px;
                            text-align: right;
                            margin-bottom: 10px;
                            span{
                                margin-left: 10px;
                            }
                        }
                        .topBox{
                            .imgBox{
                                position: relative;
                                width: 52px;
                                height: 52px;
                                float: left;
                                margin-right: 10px;
                                .acartImg{
                                    width: 52px;
                                    height: 52px;
                                    border-radius: 50%;
                                }
                                .genderImg{
                                    position: absolute;
                                    width: 16px;
                                    height: 16px;
                                    bottom: 0;
                                    right: 0;
                                }
                            }
                            .phoneBox{
                                float: left;
                                .name{
                                    height: 22px;
                                    font-size: 14px;
                                    font-weight: 600;
                                    color: #333333;
                                    line-height: 22px;
                                    span{
                                        display: inline-block;
                                        width: 46px;
                                        height: 18px;
                                        border-radius: 3px;
                                        border: 1px solid #2026CC;
                                        line-height: 18px;
                                        text-align: center;
                                        margin-left: 10px;
                                        font-size: 12px;
                                        font-weight: 400;
                                        color: #2026CC;
                                    }
                                }
                                .year{
                                    height: 18px;
                                    font-size: 12px;
                                    font-weight: 400;
                                    color: #666666;
                                    line-height: 18px;
                                    margin: 10px 0 6px 0;
                                }
                                .numberBox{
                                    height: 18px;
                                    font-size: 12px;
                                    font-weight: 400;
                                    color: #666666;
                                    line-height: 18px;
                                    .phone{
                                        margin-right: 20px;
                                        img{
                                            width: 12px;
                                            height: 16px;
                                            margin-right: 5px;
                                            vertical-align: text-bottom;
                                        }
                                    }
                                    .email{
                                        margin-right: 20px;
                                        img{
                                            width: 14px;
                                            height: 12px;
                                            margin-right: 5px;
                                            vertical-align: text-bottom;
                                        }
                                    }
                                    .wechat{
                                        img{
                                            width: 16px;
                                            height: 14px;
                                            margin-right: 5px;
                                            vertical-align: text-bottom;
                                        }
                                    }
                                }
                            }
                            .upload{
                                float: right;
                                margin-top: 32px;
                                .upload1{
                                    display: inline-block;
                                    text-align: center;
                                    margin-right: 15px;
                                    img{
                                        width: 18px;
                                        height: 19px;
                                    }
                                    p{
                                        height: 17px;
                                        font-size: 12px;
                                        font-weight: 400;
                                        color: #333333;
                                        line-height: 17px;
                                        margin-top: 4px;
                                    }
                                }
                                .upload2{
                                    display: inline-block;
                                    text-align: center;
                                    margin-right: 15px;
                                    img{
                                        width: 18px;
                                        height: 19px;
                                    }
                                    p{
                                        height: 17px;
                                        font-size: 12px;
                                        font-weight: 400;
                                        color: #333333;
                                        line-height: 17px;
                                        margin-top: 4px;
                                    }
                                }
                                .upload4{
                                    display: inline-block;
                                    text-align: center;
                                    margin-right: 15px;
                                    img{
                                        width: 18px;
                                        height: 19px;
                                    }
                                    p{
                                        height: 17px;
                                        font-size: 12px;
                                        font-weight: 400;
                                        color: #999999;
                                        line-height: 17px;
                                        margin-top: 4px;
                                    }
                                }
                                .upload3{
                                    display: inline-block;
                                    text-align: center;
                                    img{
                                        width: 18px;
                                        height: 17px;
                                    }
                                    p{
                                        height: 17px;
                                        font-size: 12px;
                                        font-weight: 400;
                                        color: #333333;
                                        line-height: 17px;
                                        margin-top: 4px;
                                    }
                                }
                            }
                        }
                    }
                    .scrollBox{
                        overflow: hidden;
                        width: 100%;
                        .titleBox{
                            padding-right: 17px;
                            margin-right: -17px;
                            overflow-y: auto;
                            height: 718px;
                            width: 100%;
                            padding-top: 20px;
                            .boxLi{
                                padding: 0 3px 0 20px;
                                .content1{
                                    margin-bottom: 40px;
                                    .titleHead{
                                        height: 24px;
                                        font-size: 16px;
                                        font-weight: 600;
                                        color: #333333;
                                        line-height: 24px;
                                        margin-bottom: 20px;
                                    }
                                    .textBox{
                                        margin-bottom: 20px;
                                        .htmlText{
                                            font-size: 14px;
                                            font-weight: 400;
                                            color: #666666;
                                            line-height: 28px;
                                            padding-left: 18px;
                                        }
                                        .htmlText1{
                                            padding-left: 0;
                                        }
                                        .textName{
                                            font-size: 14px;
                                            font-weight: 600;
                                            color: #333333;
                                            line-height: 22px;
                                            span{
                                                width: 8px;
                                                height: 8px;
                                                background: #2026CC;
                                                display: inline-block;
                                                border-radius: 50%;
                                                margin-right: 10px;
                                                vertical-align: top;
                                                margin-top: 7px;
                                            }
                                            p.name{
                                              display: inline-block;
                                              line-height: 22px;
                                              width: 612px;
                                            }
                                            i{
                                                font-size: 14px;
                                                font-weight: 400;
                                                color: #999999;
                                                margin-left: 20px;
                                                b{
                                                  font-weight: 400;
                                                }
                                            }
                                        }
                                        .time{
                                            font-size: 14px;
                                            font-weight: 500;
                                            color: #333333;
                                            line-height: 22px;
                                            margin: 10px 0;
                                            padding-left: 18px;
                                            span{
                                                font-size: 14px;
                                                font-weight: 400;
                                                color: #999999;
                                                margin-left: 20px; 
                                                vertical-align: top;
                                                b{
                                                  font-weight: 400;
                                                }
                                            }
                                            p{
                                              display: inline-block;
                                              max-width: 75%;
                                            }
                                        }
                                        .link{
                                            height: 22px;
                                            font-size: 14px;
                                            font-weight: 400;
                                            color: #666666;
                                            line-height: 22px;
                                            margin-top: 10px;
                                            padding-left: 18px;
                                            a{
                                                color: #2026CC;
                                            }
                                        }
                                        .education{
                                            padding-left: 18px;
                                            height: 18px;
                                            font-size: 12px;
                                            font-weight: 400;
                                            color: #666666;
                                            line-height: 18px;
                                            margin-top: 10px;
                                        }
                                    }
                                }
                                .content2{
                                    margin-bottom: 40px;
                                    .titleHead{
                                        height: 24px;
                                        font-size: 16px;
                                        font-weight: 600;
                                        color: #333333;
                                        line-height: 24px;
                                        margin-bottom: 30px;
                                    }
                                    .videoList{
                                        .videoLi{
                                            float: left;
                                            width: 305px;
                                            margin-right: 20px;
                                            margin-bottom: 20px;
                                            &:nth-child(2n) {
                                                margin-right: 0;
                                            }
                                            img{
                                                width: 305px;
                                                height: 170px;
                                            }
                                            .videoTitle{
                                                height: 40px;
                                                font-size: 14px;
                                                font-weight: 400;
                                                color: #0A0A0A;
                                                line-height: 20px;
                                                margin: 10px 0;
                                                overflow: hidden;
                                                text-overflow: ellipsis;
                                                display: -webkit-box;
                                                -webkit-box-orient: vertical;
                                                -webkit-line-clamp: 2;
                                                word-break: break-word;
                                            }
                                            .tags{
                                                height: 18px;
                                                font-size: 12px;
                                                font-weight: 400;
                                                color: #999999;
                                                line-height: 18px;
                                                overflow: hidden;
                                                text-overflow: ellipsis;
                                                white-space: nowrap;
                                                span{
                                                    margin-right: 10px;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        .fileBox{
                            padding: 20px 0 30px 0;
                            text-align: center;
                            img{
                                width: 150px;
                                height: 130px;
                            }
                            p{
                                font-size: 14px;
                                font-weight: 400;
                                color: #333333;
                                line-height: 22px;
                                margin-top: 20px;
                            }
                        }
                    }
                }
            }
            .seeed{
                background: #F8F8F8;
            }
            .noData{
                text-align: center;
                padding: 92px 0 400px 0;
                img{
                    width: 284px;
                    height: 276px;
                }
                p{
                    height: 22px;
                    font-size: 16px;
                    font-weight: 400;
                    color: #354052;
                    line-height: 22px;
                    margin-top: 40px;
                }
            }
        }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/my/account/Resume.vue